import { render } from "./CxDhScaleLegend.vue?vue&type=template&id=bf365690"
import script from "./CxDhScaleLegend.vue?vue&type=script&lang=js"
export * from "./CxDhScaleLegend.vue?vue&type=script&lang=js"

import "./CxDhScaleLegend.vue?vue&type=style&index=0&id=bf365690&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__